import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";

export interface ProgramCategoriesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly description?: string;
}

export const programCategoriesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 240,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 360,
    sort: true,
  },
  {
    title: "Programs",
    key: "programsCount",
    width: 120,
    sort: true,
    type: "badge",
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const programCategoriesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.StartsWith },
  { formField: "description", operation: QueryOperation.StartsWith },
];

export const mapProgramCategoriesViewQuery = (
  values: ProgramCategoriesForm,
): SearchQuery => buildSearchQuery(values, programCategoriesQueryMappings);
